<template>
	<div class="container">
		<!-- 左侧内容 -->
		<div class="left-column">
			<div style="color:#3a8ee6;padding-right: 20px;text-align: right;
			height: 35px;line-height: 35px;">*提示：鼠标移入节点可以操作增册改！</div>
			<el-tree ref="gyszlTree" :data="treeData" node-key="id" :props="defaultProps" :default-expanded-keys="defaultExpandedNodes" highlight-current
				:allow-drop="allowDrop" @node-click="handleNodeClick" @node-drop="handleDrop">
				<span class="custom-tree-node" slot-scope="{ node, data }">
					<span>{{ data.isHide==1?'【隐藏】':'' }}{{ node.label }}</span>
					<span class="rightOperateBtn">
						<el-button type="text" size="mini"  title="新建子类" @click.stop="handleAppend(data)" v-if="data.groupType==1 || data.groupType==2"
							icon="el-icon-plus"></el-button>
						<el-button v-if="data.groupType==2 || data.groupType==3" type="text" title="删除" size="mini" @click.stop="handleRemove(data)"
							icon="el-icon-delete"></el-button>
					</span>
				</span>
			</el-tree>
		</div>
		<div class="separator"></div>
		<div class="right-column">
			<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
				<el-form :inline="true" :model="filters">
					<el-form-item>
						<el-button @click="handleAppend({})" size="small">重置</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="handleSubmit()" size="small">保 存</el-button>
					</el-form-item>
				</el-form>
			</el-col>
			<el-form :rules="userRules" label-position="right" ref="addForm" :model="addForm" label-width="70px"
				class="postForm" style="margin-left: 10px;">
				<el-form-item label="上级分类:" label-width="150px" prop="parentId">
					<el-input v-model="addForm.parentTypeName" auto-complete="off" disabled class="formItem" size="small"
						maxLength="50" />
				</el-form-item>
				<el-form-item :label="groupLabel" label-width="150px" prop="groupName" class="notBlank">
					<el-input v-model="addForm.groupName" auto-complete="off" class="formItem" size="small"
						maxLength="150" />
				</el-form-item>

				<el-form-item label="排序:" label-width="150px" prop="sortNum">
					<el-input v-model="addForm.sortNum" auto-complete="off" class="formItem" size="small" maxLength="50" />
				</el-form-item>
				<el-form-item label="隐藏:" label-width="150px" prop="sortNum" v-if="addForm.groupType==2">
					<el-checkbox v-model="addForm.isHide" :true-label="1" :false-label="0" size="small"></el-checkbox>
				</el-form-item>

			</el-form>
		</div>
	</div>
</template>
<style lang="scss" scoped>
.container {
	display: flex;
	.labl1 {
		background-color: #ecf5ff;
		display: inline-block;
		height: 32px;
		margin: 5px;
		padding: 0 10px;
		line-height: 30px;
		font-size: 12px;
		color: #409eff;
		border: 1px solid #d9ecff;
		border-radius: 4px;
		box-sizing: border-box;
		white-space: nowrap;
	}
}

/* 定义左侧列样式 */
.left-column {
	width: 30%;
	background-color: #ffffff;

	.el-tree {
		.custom-tree-node {
			flex: 1;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding-right: 8px;
			font-weight: bolder;
			font-size: 14px;
		}

		.el-tree-node__children {
			.custom-tree-node {
				font-weight: normal;
				font-size: 14px;
			}
		}

		.custom-tree-node {
			.rightOperateBtn {
				display: none;
			}

			&:hover {
				.rightOperateBtn {
					display: block;
				}
			}
		}

		.is-current {
			.custom-tree-node {
				color: black;
				font-weight: bolder;
			}

			.el-tree-node__children {
				.custom-tree-node {
					color: #606266;
					font-weight: normal;
				}
			}
		}
	}
}

/* 定义右侧列样式 */
.right-column {
	width: 70%;
	background-color: #ffffff;
	text-align: left;
}

/* 定义中间分隔线样式 */
.separator {
	width: 1px;
	height: calc(100vh - 110px);
	margin: auto;
	background-color: #e9e4e4;
}
</style>
<script>
export default {
	data() {
		return {
			filters: {
				id: 0,
				parentId: 0,
				sortNum: 0,
				"isDrag": 0,
				fromType:2
			},
			addForm: {
				id: 0,
				groupName:'',
				parentId:0,
				groupType:0,
				sortNum:0,
				parentTypeName: "",
				"isDrag": 0,	
				isHide:0,
				fromType:2
			},
			userRules: {},
			defaultProps: {
				children: 'children',
				label: 'groupName'
			},
			treeData: [],
			sels: [],//列表选中列
			showTitle: "",
			mid: 0,
			groupLabel:"分类名：",
			defaultExpandedNodes:[1566]
		}
	},
	methods: {
		//删除
		delInfo: function (id) {
			this.$confirm('确认删除该记录吗?', '提示', {
				type: 'warning'
			}).then(() => {
				let formData = new FormData();
				formData.append("id", id);
				this.$axios.post("/exercise/exercisegroupdel", formData).then(res => {
					if (res.data.status == 0) {
						this.$message("删除成功!");
						this.getTreeData();
					} else {
						this.$message(res.data.msg);
					}
				});
			});
		},
		// 添加
		handleAppend(data) {
			this.addForm.parentId = data.id || 0;
			this.addForm.parentTypeName = data.groupName || "根目录";
			this.addForm.isDrag = 0;
			this.addForm.groupName = "";
			this.addForm.sortNum = 0;
			this.addForm.id = 0;
			this.addForm.isHide=0
			this.addForm.fromType=2
			if(data.groupType==1){
				this.groupLabel="单元名称："
				this.addForm.groupType=2
			}
			else if(data.groupType==2){
				this.groupLabel="章节名称："
				this.addForm.groupType=3
			}
			else {
				this.groupLabel="分类名："
				this.addForm.groupType=1
			}
		},
		// 编辑
		async handleEdit(data) {
			let info = (await this.$axios.get("/exercise/getexercisegroupinfo?id=" + data.id + "&rnd=" + new Date().getTime())).data.data;
			this.addForm.groupName = info.groupName
			this.addForm.groupType = info.groupType
			this.addForm.sortNum = info.sortNum
			this.addForm.id = info.id;
			this.addForm.parentId = info.parentId;
			this.addForm.isHide=info.isHide
			this.addForm.parentTypeName = "";
			if (this.addForm.parentId > 0) {
				this.addForm.parentTypeName = (await this.$axios.get("/exercise/getexercisegroupinfo?id=" + this.addForm.parentId + "&rnd=" + new Date().getTime())).data.data.groupName;
			}
			else {
				this.addForm.parentTypeName = "根目录";
			}
			this.addForm.isDrag = 0;
			if(data.groupType==2){
				this.groupLabel="单元名称："
			}
			else if(data.groupType==3){
				this.groupLabel="章节名称："
			}
			else this.groupLabel="分类名："
		},
		// 删除
		handleRemove(data) {
			this.delInfo(data.id)
		},
		// 设置可拖拽范围
		allowDrop(draggingNode, dropNode, type) {
			if (dropNode.level != 1) {
				return true;
			} else {
				return false;
			}
		},
		// 点击树节点
		handleNodeClick(data) {
			if (data.id > 0 && data.groupType>1) {
				this.handleEdit(data);
			}
		},
		// 拖拽
		async handleDrop(draggingNode, dropNode, dropType, ev) {
			let obj = {
				"id": draggingNode.data.id,
				"groupName": draggingNode.data.groupName,
				"groupType": draggingNode.data.groupType,
				"isDrag": 1,
			}
			if (dropType == "inner") {
				obj.parentId = dropNode.data.id;
				let children = dropNode.data.children;
				for (let i = 0; i < children.length; i++) {
					if (children[i].id == draggingNode.data.id) {
						obj.sortNum = (i + 1);
					}
				}
			} else {
				obj.parentId = dropNode.parent.data.id
				obj.sortNum = dropNode.data.sortNum;
			}
			this.addForm = JSON.parse(JSON.stringify(obj))
			this.handleSubmit();
		},
		handleSubmit() {
			if(this.addForm.groupType<=1){
				this.$message("请选择新增或编辑记录!");
				return;
			}
			let formData = this.$util.jsonToForm(this.addForm);
			this.$axios.post("/exercise/exercisegroupsave", formData).then(res => {
				if (res.data.status == 0) {
					this.$message("保存成功!");
					this.getTreeData();
					this.addForm.id=0;
					this.addForm.groupName="";
					this.addForm.groupType=0
					this.addForm.sortNum=0;
					this.addForm.isHide=0
					//this.$refs.gyszlTree.setCurrentKey([3])
					this.defaultExpandedNodes=[this.addForm.parentId]
				} else {
					this.$message(res.data.msg);
				}
			});

		},
	},
async created() {
		this.treeData = [{ "id": 0, groupName: "全部", children: await this.getExerciseGroupTreeData(2), groupType: 0,fromType:2 }]
	}
}

</script>
